import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

export interface TabItem {
  id: string;
  label: string;
  icon?: any;
  disabled?: boolean;
  badge?: string | number;
  showHelp?: boolean;
}

@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, TranslateModule],
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent {

  @Input() tabs: TabItem[] = [];
  @Input() activeId?: string;
  @Input() variant: 'underline' | 'pill' | 'solid' = 'underline';
  @Input() fullWidth: boolean = false;
  @Output() activeIdChange = new EventEmitter<string>();
  @Output() tabSelected = new EventEmitter<TabItem>()

  faQuestionCircle = faQuestionCircle;;
  @Output() helpClicked = new EventEmitter<string>();

  onTabClick(tab: TabItem): void {
    if (tab.disabled) return;
    if (this.activeId === tab.id) return;

    this.activeId = tab.id;
    this.activeIdChange.emit(tab.id);
    this.tabSelected.emit(tab);
  }

  isActive(tab: TabItem): boolean {
    return this.activeId === tab.id;
  }

  trackById(index: number, tab: TabItem): string {
    return tab.id;
  }

  onHelpClick(event: Event, tabId: string): void {
    event.stopPropagation();
    this.helpClicked.emit(tabId);
  }
}
